import React from 'react';
import { Card, Button } from 'react-bootstrap';


const DownloadCard = () => {


    return (
        <section className='sch' id='schedule'>
            <h1 style={{
                textAlign: "center"
            }} >SCHEDULE</h1>
            <Card
                className="my-4 container"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    background: 'linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)',
                    border: 'none',
                    boxShadow: 'none',
                    color: 'white',
                }}
            >
                <Card.Body style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <div>
                        <h5>Schedule</h5>
                    </div>
                    <Button
                        variant="light"
                        onClick={() => window.open("/s.pdf", "_blank")}
                        style={{
                            color: 'black',
                            backgroundColor: 'gold',
                            border: '2px solid black',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease',
                            padding: '8px 20px',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = 'gold')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
                    >
                        Download
                    </Button>
                </Card.Body>
            </Card>
        </section>
    );
};

export default DownloadCard;
